import { Marker } from "react-map-gl/mapbox";
import Map, { type ICoordinatePair } from "@/components/Map/Map";
import { getValidCoordinates } from "@/forms/coordinatesUtils";
import { useCareHub } from "@/api/Patients";

const PREFERRED_EDIT_ADDRESS_ZOOM = 13;
const MAX_DISTANCE_FROM_CARE_HUB_IN_METERS = 150_000;

export const PatientMap = ({
  coordinates,
  liveEdit,
  style,
  allowScrollZoom,
}: {
  coordinates: ICoordinatePair;
  liveEdit?: {
    areCoordinatesDirty: boolean;
    coordinatesFailedToFetch: boolean;
  };
  style: { height: "100%" | "30vh" };
  allowScrollZoom: boolean;
}) => {
  const { data: careHub } = useCareHub();

  const longitude = coordinates.longitude;
  const latitude = coordinates.latitude;

  const coordinatesProvided =
    Boolean(longitude && latitude) || liveEdit?.areCoordinatesDirty;

  // If coordinates are provided, allow scroll zoom if allowed, otherwise disable scroll zoom
  // If no coordinates are provided, disable all handlers
  const disabledHandlers = coordinatesProvided
    ? allowScrollZoom
      ? undefined
      : "scrollZoom"
    : "all";

  return (
    <Map
      key={`${latitude},${longitude}`}
      initialAreaToShow={{
        center: { lat: latitude, lng: longitude },
        zoom: PREFERRED_EDIT_ADDRESS_ZOOM,
      }}
      disabledHandlers={disabledHandlers}
      id="registerPatientMap"
      style={style}
    >
      {coordinatesProvided &&
      !liveEdit?.coordinatesFailedToFetch &&
      longitude &&
      latitude ? (
        (() => {
          if (!careHub) {
            return <></>;
          }
          const validCoordinates = getValidCoordinates({
            longitude,
            latitude,
            careHub,
            maxDistance: MAX_DISTANCE_FROM_CARE_HUB_IN_METERS,
          });
          if (validCoordinates) {
            return (
              <Marker
                longitude={validCoordinates.longitude}
                latitude={validCoordinates.latitude}
              />
            );
          } else {
            return <></>;
          }
        })()
      ) : (
        <></>
      )}
    </Map>
  );
};
